import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG_CHAUFFEUR } from "../../lib/assets";
import { useLang } from "../../lib/i18n";

export const Experiences = () => {
  const ref = useRef(null);
  const { t } = useLang();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="experiences" ref={ref} className="relative bg-[#0A192F] py-24 md:py-32 overflow-hidden" data-testid="experiences-section">
      <div className="noise-overlay" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-5"
        >
          <p className="font-script text-[#C9A03C] text-2xl mb-4">{t.exp.eyebrow}</p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl text-[#F0F0F0] font-medium leading-tight mb-8">
            {t.exp.title}
          </h2>
          <p className="text-[#F0F0F0]/60 font-light leading-relaxed mb-6">{t.exp.p1}</p>
          <p className="text-[#F0F0F0]/60 font-light leading-relaxed mb-10">{t.exp.p2}</p>
          <a
            href="#devis"
            data-testid="experiences-cta"
            className="inline-block px-8 py-3.5 border border-[#C9A03C] text-[#C9A03C] text-[13px] tracking-[0.16em] uppercase hover:bg-[#C9A03C] hover:text-[#050B14] transition-colors duration-400"
          >
            {t.exp.cta}
          </a>
        </motion.div>

        <div className="md:col-span-6 md:col-start-7">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="relative aspect-[4/5] md:aspect-[3/4] overflow-hidden"
          >
            <motion.img style={{ y }} src={IMG_CHAUFFEUR} alt={t.exp.imgAlt} className="w-full h-[116%] object-cover" />
            <div className="absolute inset-0 border border-[#C9A03C]/30 m-5 pointer-events-none" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
